import React, { useEffect } from 'react';
import styled from 'styled-components';
import Lottie from 'lottie-react';
import ThankyouImg from '../assets/thankyou.json';
import { config } from '../config';
import { MyAccountAccess } from '../components/MyAccountAccess';
import { clearLocalStorage } from '../utils/utils';

const Wrapper = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background-color: #fff200;
  position: relative;
`;

const LottieWrapper = styled.div`

`;

const Content = styled.div`
  background-color: white;
  width: 100%;
  height: 100vh;
  border-top-left-radius: 40px;
  border-top-right-radius: 40px;
  padding: 32px 24px;
  margin-top: 10px;
  text-align: center;
`;

const MainText = styled.div`
  font-size: 28px;
  line-height: 32px;
  font-weight: 600;
  color: #2c2c2c;
  text-align: center;
  margin: 16px 0;
`;

const Subtext = styled.h4`
  font-size: 20px;
  line-height: 28px;
  font-weight: 500;
  color: #2c2c2c;
  text-align: center;
  margin: 24px 0;
`;

const Note = styled.p`
  font-size: 14px;
  line-height: 20px;
  color: #666;
  text-align: center;
  margin: 24px auto;
  max-width: 500px;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  margin: 24px 0;
  
  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: center;
    gap: 24px;
  }
`;

const Button = styled.button`
  width: 80%;
  max-width: 300px;
  padding: 12px 24px;
  background-color: #ffe600;
  color: black;
  font-size: 18px;
  font-weight: 600;
  border: none;
  border-radius: 50px;
  cursor: pointer;

  @media (min-width: 768px) {
    width: auto;
    min-width: 200px;
  }

  &:hover {
    background-color: #ffd700;
  }
`;

const HelpText = styled.div`
  margin-top: 16px;
  font-size: 14px;
  text-align: center;
  color: #666;

  a {
    color: #00b894;
    text-decoration: none;
    font-weight: 600;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const Disclaimer = styled.p`
  font-size: 12px;
  color: #666;
  margin-top: 16px;
  margin-bottom: 16px;
  padding: 8px;
  background-color: #f5f5f5;
  border-radius: 8px;
  line-height: 1.4;
`;

const Verificacion = () => {
  useEffect(() => {
    // Limpiar localStorage después de un delay para permitir que MyAccountAccess termine de cargar
    const timer = setTimeout(() => {
      clearLocalStorage();
    }, 3000); // 3 segundos de delay

    return () => clearTimeout(timer);
  }, []);

  return (
    <Wrapper>
      <MainText>¡Ya recibimos tu solicitud!</MainText>
      <LottieWrapper>
        <Lottie animationData={ThankyouImg} style={{ width: '150px' }} />
      </LottieWrapper>
      <Content>
        <Subtext>En las próximas 24 hs recibirás el dinero en tu cuenta*</Subtext>
        <Disclaimer>
          *Sujeto a verificación final de la información brindada.
        </Disclaimer>

        <Note>
          Si necesitamos información adicional o hay algún dato por verificar, te contactaremos a través de los datos de contacto que proporcionaste.
        </Note>

        <ButtonContainer>
          <MyAccountAccess />
          <Button onClick={() => window.location.href = 'https://www.prestix.com.ar/'}>
            FINALIZAR
          </Button>
        </ButtonContainer>
        
        <HelpText>
          <a href={`https://api.whatsapp.com/send/?phone=${config.business.phone}`} target="_blank" rel="noopener noreferrer">
            AYUDA
          </a>
        </HelpText>
      </Content>
    </Wrapper>
  );
};

export default Verificacion;
